import type { FC } from 'react'

/**
 * The SVG filters behind every frayed paper edge (the `.fray` class). Rendered once in _app.
 * Turbulence displaces the edge of a background-only layer, so text above it stays crisp.
 */
export const PaperFilters: FC = () => {
    return (
        <svg aria-hidden='true' focusable='false' width='0' height='0' className='pointer-events-none absolute h-0 w-0 overflow-hidden'>
            <filter id='paper-fray' x='-3%' y='-3%' width='106%' height='106%'>
                <feTurbulence type='fractalNoise' baseFrequency='0.052' numOctaves='2' seed='11' result='noise' />
                <feDisplacementMap in='SourceGraphic' in2='noise' scale='6' />
            </filter>
            <filter id='paper-fray-bold' x='-5%' y='-5%' width='110%' height='110%'>
                <feTurbulence type='fractalNoise' baseFrequency='0.034' numOctaves='2' seed='11' result='noise' />
                <feDisplacementMap in='SourceGraphic' in2='noise' scale='11' />
            </filter>
        </svg>
    )
}
